<div [@showHide]="visibility" class="progress">
  <div class="indeterminate"></div>
</div>